/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';
import HeaderNew from '../../PageStructure/Header/HeaderNew';

export default function LoadingPageText({ showHeader, children }) {
  const [completed, setCompleted] = React.useState(0);

  React.useEffect(() => {
    function progress() {
      setCompleted(oldCompleted => {
        if (oldCompleted === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldCompleted + diff, 100);
      });
    }

    const timer = setInterval(progress, 400);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <React.Fragment>
      {showHeader && <HeaderNew />}
      <LinearProgress variant="determinate" value={completed} />
      <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>{children}</div>
    </React.Fragment>
  );
}
